<template>
    <div class="legacy-bind-page" style="min-width: 1400px;
         height: 700px;
         background: #f5f5f5;
         position: relative;
         z-index: 1;
    ">
        <div class="legacy-bind-intro" style="width: 100%;text-align: center;padding-top: 80px;">
            <img src="../assets/anquan.png" alt="" width="38px" height="49px" style="position: absolute">
            <span style="font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                margin-left: 50px;">
                为了您的安全，请绑定手机号，绑定后可使用该手机号快捷登录
            </span>
        </div>
        <div style="margin: 40px;"></div>
        <div class="legacy-bind-form" style="
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);">
            <el-form :label-position="'right'" :model="formLabelAlign" :rules="phone_login_rules" ref="phoneLoginRef">
                <el-form-item prop="phone">
                    <span style="font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: rgb(51, 51, 51);
                    position: absolute;
                    float: left;
                    border: 1px solid #dcdfe6;
                    background: white;
                    padding: 0 10px;
                    height: 38px;
                    width: 34px;
                    border-radius: 4px;">+86</span>
                    <el-input v-model="formLabelAlign.phone" style="margin-left: 54px;width: 370px;"
                              placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="validate">
                    <el-input v-model="formLabelAlign.validate" style="width: 304px;"
                              placeholder="请输入4位验证码"></el-input>
                    <span>
                        <img style="float: right;height: 39px;border-radius: 4px;cursor: pointer" :src="qrcodeUrl"
                             alt="验证码加载失败..."
                             data-track-text="刷新图形验证码"
                             aria-label="刷新图形验证码"
                             @click="getValicode"/>
                    </span>
                </el-form-item>
                <el-form-item prop="phoneValidate" style="width: 284px;">
                    <el-input v-model="formLabelAlign.phoneValidate" placeholder="请输入6位验证码"></el-input>
                    <span v-show="Verification" style="    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: rgb(28, 80, 167);
                    position: absolute;
                    width: 140px;
                    background: white;
                    border: 1px solid #dcdfe6;
                    height: 38px;
                    border-radius: 4px;
                    cursor: pointer;
                    " data-track-text="绑定手机获取验证码" aria-label="绑定手机获取验证码" @click="handleTimeClick">
                        获取手机验证码
                    </span>
                    <span v-show="!Verification" style="    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: rgb(28, 80, 167);
                    position: absolute;
                    width: 140px;
                    background: white;
                    border: 1px solid #dcdfe6;
                    height: 38px;
                    border-radius: 4px;
                    cursor: pointer;
                    ">
                        {{timers}}秒后重新获取
                    </span>
                </el-form-item>
                <el-form-item prop="checked">
                    <el-checkbox class="mycheckbox" style="
                float: left;
                font-size: 14px;
                font-family: NotoSansHans;
                font-weight: 400;
                color: #666666;" v-model="formLabelAlign.checked">
                        我已阅读并同意遵守
                    </el-checkbox>
                    <span style="float: left;
                font-size: 14px;
                font-family: NotoSansHans;
                font-weight: 400;
                color: #1c50a7;cursor: pointer" data-track-text="绑定手机查看用户服务协议" aria-label="绑定手机查看用户服务协议" @click="openAgreement">《用户服务协议》</span>
                </el-form-item>
                <el-form-item v-if="errorTitle!==''">
                    <div style="width: 100%;color: red;font-size: 14px">{{errorTitle}}</div>
                </el-form-item>
                <el-form-item>
                    <div data-track-text="提交绑定手机" aria-label="提交绑定手机" @click="submitPhoneBindFrom" style="cursor: pointer;
                    width: 424px;
                    height: 48px;
                    background: #184482;
                    border-radius: 2px;">
                <span style="
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ffffff;">
                        绑定手机
                </span>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {authServiceClient} from "../tools/api/service";
    import {checkPhoneRequest, phoneCodeRequest, valicodeRequest, phoneBindRequest} from "../tools/api/auth-api";

    export default {
        name: "Bind",
        data() {
            return {
                timers: 60,
                Verification: true,
                errorTitle: "",
                isBind: false,
                formLabelAlign: {
                    phone: "",
                    validate: "",
                    phoneValidate: "",
                    checked: true
                },
                phone_login_rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号", trigger: "blur"},
                        {validator: this.validatePhone, trigger: 'blur'}
                    ],
                    validate: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
                    ],
                    phoneValidate: [
                        {validator: this.validatePhoneCode, trigger: 'blur'}
                    ],
                    checked: [
                        {validator: this.validateChecked, trigger: 'change'}
                    ]
                },
                qrcodeUrl: undefined
            }
        },
        created() {
            this.getValicode()
        },
        methods: {
            openAgreement() {
                window.open("/agreement");
            },
            submitPhoneBindFrom() {
                this.isBind = true;
                const openid = this.$route.params.openid;
                const type = this.$route.params.type;
                this.$refs.phoneLoginRef.validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    let request = phoneBindRequest;
                    request.setPhone(this.formLabelAlign.phone);
                    request.setPhoneCode(this.formLabelAlign.phoneValidate);
                    request.setOpenid(openid)
                    request.setType(type)
                    const TOKEN_KEY = 'token';
                    const CODE_KEY = 'code';
                    let metadata;
                    if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
                        metadata = {
                            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                            [CODE_KEY]: localStorage.getItem(CODE_KEY)
                        }
                    } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
                        metadata = {
                            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
                        }
                    } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
                        metadata = {
                            [CODE_KEY]: localStorage.getItem(CODE_KEY)
                        }
                    } else {
                        metadata = {}
                    }
                    authServiceClient.phoneBind(request, metadata).then(res => {
                        if (res.getStatus() === 0) {
                            this.$message({
                              center: true,
                              type: 'success',
                              showClose: true,
                              duration: 3000,
                              message: res.getMessage()
                            });
                            this.$router.push("/index")
                            // window.location.reload()
                            return;
                        }
                        if(res.getStatus() === 4){
                            this.$message({
                                center: true,
                                type: 'success',
                                showClose: true,
                                duration: 3000,
                                message: "绑定成功"
                            });
                            window.open("https://user.wesitrans.com/account", "_self");
                            return;
                        }
                        this.errorTitle = res.getMessage();
                        this.getValicode();
                        this.isLogin = false;
                    }).catch(err => {
                        if (err && err.code === 5) {
                            this.$router.push("/login")
                        }
                        this.isLogin = false;
                    })
                });
                this.isBind = false;
            },
            validateChecked(rule, value, callback) {
                if (!value) {
                    callback(new Error('请阅读并同意协议'))
                    return
                }
                callback()
            },
            handleTimeClick() {
                this.$refs.phoneLoginRef.validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    const that = this;
                    let request = phoneCodeRequest;
                    request.setCode(this.formLabelAlign.validate)
                    request.setPhone(this.formLabelAlign.phone)
                    const CODE_KEY = 'code';
                    let metadata;
                    if (localStorage.getItem(CODE_KEY)) {
                        metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
                    } else {
                        metadata = {}
                    }
                    authServiceClient.sendPhoneCode(request, metadata)
                        .then(res => {
                            if (res.getStatus()) {
                                that.messages = "";
                                that.Verification = false;
                                this.auth_timer = setInterval(() => {
                                    that.timers--;
                                    if (that.timers <= 0) {
                                        that.Verification = true;
                                        that.timers = 60;
                                        clearInterval(that.auth_timer)
                                    }
                                }, 1000)
                                return;
                            }
                            that.getValicode();
                            that.messages = "验证码错误"
                            that.Verification = true;
                            that.timers = 60;
                        }).catch(err => {
                        that.getValicode();
                        that.messages = "手机验证码发送失败"
                        that.Verification = true;
                        that.timers = 60;
                    });
                });
            },
            validatePhone(rule, value, callback) {
                let request = checkPhoneRequest;
                request.setPhone(value);
                authServiceClient.checkPhone(request, null).then(res => {
                    if (res.getStatus() === 1) {
                        callback(new Error('手机号有误'))
                        return;
                    }
                    if (res.getStatus() === 3) {
                        this.errorTitle = '手机号未注册，您确定绑定当前手机号吗？'
                        callback()
                        return;
                    }
                    if (res.getStatus() === 2) {
                        callback(new Error('账号已被冻结'))
                        return;
                    }
                    this.errorTitle = '手机号已注册，您确定绑定到当前用户吗？'
                    callback()
                }).catch(err => {
                    callback(new Error('校验出错'));
                })
            },
            validatePhoneCode(rule, value, callback) {
                if (!this.isBind) {
                    callback()
                    return
                }
                if (value === null || value === undefined || value === "") {
                    callback(new Error('请输入手机验证码'))
                    return;
                }
                if (value.length > 6 || value.length < 6) {
                    callback(new Error('请输入6位手机验证码'))
                    return;
                }
                callback()
            },
            getValicode() {
                const CODE_KEY = 'code';
                let metadata;
                if (localStorage.getItem(CODE_KEY)) {
                    metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
                } else {
                    metadata = {}
                }
                authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
                    this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #1c50a7;
        border-color: #1c50a7;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #1c50a7;
    }

    /deep/ .el-checkbox.is-bordered.is-checked {
        border-color: #1c50a7;
    }

    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #CCC;
    }
</style>

<style lang="less" scoped>
@media (max-width: 768px) {
  .legacy-bind-page {
    width: 100%;
    min-width: 0 !important;
    min-height: 100vh;
    height: auto !important;
    padding: 28px 16px calc(84px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .legacy-bind-intro {
    padding-top: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .legacy-bind-intro > img,
  .legacy-bind-intro > span {
    position: static !important;
    margin: 0 !important;
  }

  .legacy-bind-intro > span {
    max-width: 280px;
    text-align: left;
    font-size: 14px !important;
    line-height: 22px;
  }

  .legacy-bind-form {
    position: static !important;
    width: 100%;
    margin-top: 28px;
    transform: none !important;
  }

  .legacy-bind-form /deep/ .el-form,
  .legacy-bind-form /deep/ .el-form-item,
  .legacy-bind-form /deep/ .el-input {
    width: 100% !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }

  .legacy-bind-form /deep/ .el-form-item:first-child .el-input {
    width: calc(100% - 56px) !important;
    margin-left: 56px !important;
  }

  .legacy-bind-form /deep/ .el-form-item:nth-child(2) .el-input {
    width: calc(100% - 112px) !important;
  }

  .legacy-bind-form /deep/ .el-form-item:nth-child(2) img {
    width: 104px;
    object-fit: cover;
  }

  .legacy-bind-form /deep/ .el-form-item:nth-child(3) .el-input {
    width: calc(100% - 142px) !important;
  }

  .legacy-bind-form /deep/ .el-form-item:nth-child(3) > div > span {
    right: 0;
    width: 140px !important;
    padding: 0 4px;
    text-align: center;
    line-height: 38px;
    box-sizing: border-box;
  }

  .legacy-bind-form /deep/ .el-form-item:last-child > div > div {
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
